(function() {
  define('tlhServicesAws',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesAws', []).factory('TlhAwsService', [
      '$http', function($http) {
        var factory;
        factory = {};
        factory.getConfig = function() {
          return $http.get('/api/s3/config', {
            cache: true
          }).then(function(response) {
            return response.data;
          });
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=aws.js.map
;
